import React, { useEffect, useState } from 'react';
import { Result, Button, Progress } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSignUp } from '../context/SignUpContext';

const StepSuccess = () => {
  const navigate = useNavigate();
  const { formData, resetForm } = useSignUp();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Auto-redirect after 5 seconds
    const redirectTimer = setTimeout(() => {
      handleGoToDashboard();
    }, 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, []);

  const handleGoToDashboard = () => {
    // User is already logged in from registration step
    // Navigate to home/dashboard
    navigate('/');
  };

  const isPJ = formData.accountType === 'SELLER_PJ';

  return (
    <div className="step-content step-success">
      <Result
        icon={<CheckCircleOutlined className="success-icon" />}
        status="success"
        title="Cadastro realizado com sucesso!"
        subTitle={
          <div className="success-subtitle">
            <p>
              Parabéns, <strong>{formData.person.first_name}</strong>!
              Sua conta {isPJ ? 'empresarial' : 'pessoal'} foi criada.
            </p>
            <p>Você já pode começar a receber pagamentos.</p>
          </div>
        }
        extra={[
          <div key="countdown" className="redirect-countdown">
            <Progress
              type="circle"
              percent={(countdown / 5) * 100}
              format={() => countdown}
              size={60}
              strokeColor="#00c444"
            />
            <p>Redirecionando em {countdown} segundos...</p>
          </div>,
          <Button
            type="primary"
            size="large"
            key="dashboard"
            onClick={handleGoToDashboard}
            className="go-dashboard-button"
          >
            Ir para o painel agora
          </Button>,
        ]}
      />

      <div className="success-features">
        <h4>O que você pode fazer agora:</h4>
        <ul>
          <li>Criar links de pagamento para seus clientes</li>
          <li>Configurar sua máquina de cartão virtual</li>
          <li>Acompanhar suas vendas em tempo real</li>
          <li>Gerenciar seus recebíveis</li>
        </ul>
      </div>
    </div>
  );
};

export default StepSuccess;
